import type { Tables } from '@/integrations/supabase/types';

// Use the Supabase generated type for client configuration
export type ClientFullData = Tables<'client_configuration'>;

// Use the Supabase generated type for the client list
export type ClientListData = Tables<'clients_list'>;

// CRM types
export type ClientStage = 'lead' | 'prospect' | 'active' | 'dormant' | 'inactive';

export type ActivityEventType = 'booking' | 'invoice' | 'note' | 'communication' | 'stage_change';
export type CommunicationType = 'email' | 'call' | 'text' | 'in_person';
export type CommunicationSource = 'manual' | 'email' | 'calendar';
export type WarmthLevel = 'warm' | 'cooling' | 'cold';

export function getWarmthLevel(warmthRatio: number | null): WarmthLevel {
  if (warmthRatio === null) return 'cooling';
  if (warmthRatio < 1.0) return 'warm';
  if (warmthRatio <= 2.0) return 'cooling';
  return 'cold';
}

// Manual type definitions for new tables/views (until Supabase types are regenerated)
export interface ClientHealthMetrics {
  client_id: string;
  owner_id: string;
  gig_count: number;
  total_revenue: number;
  avg_days_to_payment: number | null;
  cancellation_rate: number;
  last_booking_date: string | null;
  avg_days_between_bookings: number | null;
  warmth_ratio: number | null;
  avg_gear_quality: number | null;
  avg_adequate_labor: number | null;
  avg_expectation_management: number | null;
  avg_organization: number | null;
  avg_overall: number | null;
  rating_count: number;
  health_score: number | null;
}

export interface ClientActivityFeedItem {
  client_id: string;
  owner_id: string;
  event_type: ActivityEventType;
  event_date: string;
  summary: string;
  metadata: Record<string, unknown>;
}

export interface ClientNote {
  id: string;
  client_id: string;
  owner_id: string;
  content: string;
  pinned: boolean;
  created_at: string;
  updated_at: string;
}

export interface ClientCommunication {
  id: string;
  client_id: string;
  owner_id: string;
  contact_id: string | null;
  booking_id: string | null;
  comm_type: CommunicationType;
  summary: string;
  notes: string | null;
  occurred_at: string;
  source: CommunicationSource;
  created_at: string;
}

export interface BookingRating {
  id: string;
  booking_id: string;
  client_id: string;
  owner_id: string;
  gear_quality: number | null;
  adequate_labor: number | null;
  expectation_management: number | null;
  organization: number | null;
  overall: number | null;
  notes: string | null;
  created_at: string;
}

export interface ClientStageHistory {
  id: string;
  client_id: string;
  owner_id: string;
  from_stage: string | null;
  to_stage: string;
  changed_at: string;
}
